import { Lang } from '../i18n/translations';

// ============================================================================
// Blog article model.
//
// ONE ARTICLE = ONE FILE in `src/blog/articles/`. Each file exports a
// BlogArticle: metadata (slug/date/tags), optional per-article CSS, and the
// content in up to 3 language versions (en / zhHant / zhHans). Write content
// as HTML — it is rendered inside `.blog-article-content` and styled by the
// shared `blog.css`, plus your optional per-article `css`.
// ============================================================================

export interface ArticleLocale {
  title: string;
  /** Short summary shown on the blog index cards and used as meta description. */
  excerpt: string;
  /** Optional comma-separated keywords for the <meta name="keywords"> tag. */
  keywords?: string;
  /** Article body as HTML (h2/h3/p/ul/ol/table/blockquote/img/a ...). */
  contentHtml: string;
}

export interface BlogArticle {
  /** URL id: /blog/<slug> */
  slug: string;
  /** Publish date, 'YYYY-MM-DD'. */
  date: string;
  readingMinutes: number;
  tags: string[];
  /** Optional CSS scoped to this article (injected with the article only). */
  css?: string;
  /** Language versions — provide at least one; missing languages fall back. */
  locales: Partial<Record<Lang, ArticleLocale>>;
}

/** Pick the best locale for the current UI language (fallback: en, then any). */
export const getArticleLocale = (
  article: BlogArticle,
  lang: Lang
): ArticleLocale | undefined =>
  article.locales[lang] ?? article.locales.en ?? Object.values(article.locales)[0];
